/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { JobExecutionStatus } from '../models';
// @ts-ignore
import type { JobStatusSummary } from '../models';
// @ts-ignore
import type { TickerResult } from '../models';
/**
 * JobMonitoringApi - axios parameter creator
 * @export
 */
export const JobMonitoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve detailed information about a specific job execution by ID
         * @summary Get specific job execution details
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobExecutionStatus: async (executionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executionId' is not null or undefined
            assertParamExists('getJobExecutionStatus', 'executionId', executionId)
            const localVarPath = `/api/job-monitor/execution/{executionId}`
                .replace(`{${"executionId"}}`, encodeURIComponent(String(executionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of recent job executions with their status summary
         * @summary Get recent job execution history
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobHistory: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-monitor/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a lightweight summary of the latest job status for dashboard widgets
         * @summary Get job status summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-monitor/status/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the current status of the latest job execution. Optimized for <100ms response times.
         * @summary Get latest job execution status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestJobStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-monitor/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve latest job status with optimized caching for real-time monitoring dashboards
         * @summary Get live job status with caching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveJobStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/job-monitor/status/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all ticker trading results for a specific job execution
         * @summary Get ticker results for job execution
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickerResults: async (executionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executionId' is not null or undefined
            assertParamExists('getTickerResults', 'executionId', executionId)
            const localVarPath = `/api/job-monitor/execution/{executionId}/tickers`
                .replace(`{${"executionId"}}`, encodeURIComponent(String(executionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobMonitoringApi - functional programming interface
 * @export
 */
export const JobMonitoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobMonitoringApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve detailed information about a specific job execution by ID
         * @summary Get specific job execution details
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobExecutionStatus(executionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobExecutionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobExecutionStatus(executionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobMonitoringApi.getJobExecutionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of recent job executions with their status summary
         * @summary Get recent job execution history
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobHistory(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobExecutionStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobHistory(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobMonitoringApi.getJobHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a lightweight summary of the latest job status for dashboard widgets
         * @summary Get job status summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStatusSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobStatusSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStatusSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobMonitoringApi.getJobStatusSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the current status of the latest job execution. Optimized for <100ms response times.
         * @summary Get latest job execution status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestJobStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobExecutionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestJobStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobMonitoringApi.getLatestJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve latest job status with optimized caching for real-time monitoring dashboards
         * @summary Get live job status with caching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiveJobStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobExecutionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiveJobStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobMonitoringApi.getLiveJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all ticker trading results for a specific job execution
         * @summary Get ticker results for job execution
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTickerResults(executionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TickerResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTickerResults(executionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobMonitoringApi.getTickerResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobMonitoringApi - factory interface
 * @export
 */
export const JobMonitoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobMonitoringApiFp(configuration)
    return {
        /**
         * Retrieve detailed information about a specific job execution by ID
         * @summary Get specific job execution details
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobExecutionStatus(executionId: string, options?: RawAxiosRequestConfig): AxiosPromise<JobExecutionStatus> {
            return localVarFp.getJobExecutionStatus(executionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of recent job executions with their status summary
         * @summary Get recent job execution history
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobHistory(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobExecutionStatus>> {
            return localVarFp.getJobHistory(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a lightweight summary of the latest job status for dashboard widgets
         * @summary Get job status summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusSummary(options?: RawAxiosRequestConfig): AxiosPromise<JobStatusSummary> {
            return localVarFp.getJobStatusSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the current status of the latest job execution. Optimized for <100ms response times.
         * @summary Get latest job execution status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestJobStatus(options?: RawAxiosRequestConfig): AxiosPromise<JobExecutionStatus> {
            return localVarFp.getLatestJobStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve latest job status with optimized caching for real-time monitoring dashboards
         * @summary Get live job status with caching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveJobStatus(options?: RawAxiosRequestConfig): AxiosPromise<JobExecutionStatus> {
            return localVarFp.getLiveJobStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all ticker trading results for a specific job execution
         * @summary Get ticker results for job execution
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickerResults(executionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TickerResult>> {
            return localVarFp.getTickerResults(executionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobMonitoringApi - object-oriented interface
 * @export
 * @class JobMonitoringApi
 * @extends {BaseAPI}
 */
export class JobMonitoringApi extends BaseAPI {
    /**
     * Retrieve detailed information about a specific job execution by ID
     * @summary Get specific job execution details
     * @param {string} executionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getJobExecutionStatus(executionId: string, options?: RawAxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getJobExecutionStatus(executionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of recent job executions with their status summary
     * @summary Get recent job execution history
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getJobHistory(limit?: number, options?: RawAxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getJobHistory(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a lightweight summary of the latest job status for dashboard widgets
     * @summary Get job status summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getJobStatusSummary(options?: RawAxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getJobStatusSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the current status of the latest job execution. Optimized for <100ms response times.
     * @summary Get latest job execution status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getLatestJobStatus(options?: RawAxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getLatestJobStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve latest job status with optimized caching for real-time monitoring dashboards
     * @summary Get live job status with caching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getLiveJobStatus(options?: RawAxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getLiveJobStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all ticker trading results for a specific job execution
     * @summary Get ticker results for job execution
     * @param {string} executionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getTickerResults(executionId: string, options?: RawAxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getTickerResults(executionId, options).then((request) => request(this.axios, this.basePath));
    }
}

